/* tslint:disable */
/* eslint-disable */
export enum PropertyAttributes {
  None = 'None',
  SpecialName = 'SpecialName',
  RtSpecialName = 'RTSpecialName',
  HasDefault = 'HasDefault',
  Reserved2 = 'Reserved2',
  Reserved3 = 'Reserved3',
  Reserved4 = 'Reserved4',
  ReservedMask = 'ReservedMask'
}
